import type { FaireProductEntity } from "../../entity_types/product";

export const p_2g4mgmw5p5: FaireProductEntity = {
  token: "p_2g4mgmw5p5",
  type: "product",
  name: "Brass Twin Swords Spartan Warriors Crafts Desktop Ornaments",
  brandToken: "b_nex9pcmkzj",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/b99a4226cea73ad1c6a9c381823584c4aaafde06bf31322bf4c7095d14557a68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8a0f6acf08036f52fee659a436a0f9bb870072c0f49dd7c4811b0d66865a09f.jpeg",
    "https://cdn.faire.com/fastly/b0e07b7046b4d0c99e910a230cd3eaa4b0c309c2932c50373703bfb5a2dfff13.jpeg",
    "https://cdn.faire.com/fastly/f0888a58875ae1f6dcfcc57c13a515be11a6333189453710858c3bd90e63c082.jpeg",
  ],
  priceDollars: 4.71,
  description: "Type: Ornaments\n\nMaterial: Brass\n\nSize: 27mm*37mm\n\n\n",
  tags: [],
  msrpDollars: 9.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.009Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
